<template>
  <ErrorLayout>
    <p>
      {{ startDateFormat }}以降ご利用可能となります。
      {{ startDateFormat }}以降に再度ログインください
    </p>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  computed: {
    startDateFormat(){
      const error = this.$store.getters['authError/get'];
      const startDate = error.data?.startDate ? String(error.data.startDate) : null;
      if(startDate){
        let formattedDate = startDate.slice(0, 4) + "年" + startDate.slice(4, 6) + "月" + startDate.slice(6) + "日";
        return formattedDate;
      }
      return "";
    },
  },
};
</script>

<style lang="scss"></style>
